export default __webpack_public_path__ + "static/media/harshit.67506678.png";